import React from 'react'
import Navbar from '../components/Navbar'
import PistonluComp from '../components/Pistonlu_comp'
import Footer from '../components/Footer'

function PistonluUrunler() {
  return (
    <div>
        <Navbar />
        <PistonluComp />
        <Footer />
    </div>
  )
}

export default PistonluUrunler
